export const okEmptyResponse = "OK";

export enum impMode {exsistRev = 'exsistRev', newRev='newRev'}
export enum pdfMode {view = 'view', edit='edit'}
export enum saveButtonMode {save = 'save', saveAsAttachment = 'saveAsAttachment'}
export enum wfRetteType {ertms = 'ertms', retteflyt = 'retteflyt'}

export enum currPathValue { HomePage = 'HomePage', Recent='Recent', Favorites='Favorites', Search = 'Search', 
                            Activities='Activities', Document = 'Document', WfActivity='WfActivity', PdfTron = 'PdfTron', NoAccess = 'NoAccess' };

export enum LANG {
    ENG = "ENG",
    NO = "NO",
}

export enum containers {
    MAIN_CONTAINER = 'MAIN_CONTAINER',
    DATA_CONTAINER = 'DATA_CONTAINER',
    DOC_DATA_CONTAINER = 'DOC_DATA_CONTAINER',
    ACTIVITY_DATA_CONTAINER = 'ACTIVITY_DATA_CONTAINER',
    PDF_VIEWER_INIT='PDF_VIEWER_INIT',
    PDF_VIEWER_CONTAINER = 'PDF_VIEWER_CONTAINER',
}

export enum actionTypes {
    SET_LOADING = 'SET_LOADING',
    SET_VISIBLE = 'SET_VISIBLE',
    SET_ERRORED = 'SET_ERRORED',
    HAS_ACCESS = 'HAS_ACCESS',
    SET_USER = 'SET_USER',
    SET_APP_SETINGS = 'SET_APP_SETINGS',
    SET_ITEMS = 'SET_ITEMS',
    CLEAR_ITEMS = 'CLEAR_ITEMS',
    VISIBLE_TOGGLE = 'VISIBLE_TOGGLE',
    //mass upload
    // SET_UPLOAD_OP_STAGE = 'SET_UPLOAD_OP_STAGE',
    // UPDATE_UPLOAD_OP_FILE_INFO = 'UPDATE_UPLOAD_OP_FILE_INFO',
    // REMOVE_FROM_CONFIRMED = 'REMOVE_FROM_CONFIRMED',
    // ADD_TO_CONFIRMED = 'ADD_TO_CONFIRMED',
    // CHANGE_CONFIRMED_ITEMS = 'CHANGE_CONFIRMED_ITEMS',
    // ADD_TO_MATCHED = 'ADD_TO_MATCHED',
    // REMOVE_FROM_SELECTION_ITEMS = 'REMOVE_FROM_SELECTION_ITEMS',
    // ADD_OR_CHANGE_SELECTION_ITEMS = 'ADD_OR_CHANGE_SELECTION_ITEMS'

}

export enum authResult {
    SET_SUCCESS = 'SET_SUCCESS',
    SET_ERRORED = 'SET_ERRORED',
}

export enum revMode {
    LATEST_REV = 'LATEST_REV',
    CURRENT_REV = 'CURRENT_REV',
}

export enum uiItemNames {
    hasRequiredGroups = 'hasRequiredGroups',
    currentUser = 'currentUser',
    currentUserGroups = 'currentUserGroups',
    language = 'language',
    currentPath = 'currentPath',
    previousPath = 'previousPath',
    recentDocuments = 'recentDocuments',
    favoriteDocuments ='favoriteDocuments',
    myActivities = 'myActivities',
    headerText = 'headerText',
    selectedDocument = 'selectedDocument',
    documentSearchList = 'documentSearchList',
    revisionPermisions = 'revisionPermisions',
    selectedRevPermisions = 'selectedRevPermisions',
    selectedActivity = 'selectedActivity',
    activityDecisions = 'activityDecisions',
    wfDocuments = 'wfDocuments',
    OpenFileInfo = 'OpenFileInfo',
    pdfViewerClientSide = 'pdfViewerClientSide',
    pdfViewerMode = 'pdfViewerMode',
    pdfViewerSaveButtonMode = 'pdfViewerSaveButtonMode',
    errorMsgVisible = 'errorMsgVisible',
    errorMessage = 'errorMessage',
    actItemBL = 'actItemBL',
    actRecsBL = 'actRecsBL',
}

export enum buttonActionTypes  {
    GET_CONFIG = 'GET_CONFIG',
    ADD_TO_FAVORITES='ADD_TO_FAVORITES',
    REMOVE_FROM_FAVORITES='REMOVE_FROM_FAVORITES',
    GET_MY_INFO = 'GET_MY_INFO',
    GET_MY_GROUPS = 'GET_MY_GROUPS',
    GET_RECENT_DOCS = 'GET_RECENT_DOCS',
    GET_FAVORITE_DOCS = 'GET_FAVORITE_DOCS',
    GET_MY_ACTIVITIES = 'GET_MY_ACTIVITIES',
    GET_REVISION_PERMISIONS = 'GET_REVISION_PERMISIONS',
    GET_ACTIVITY_DOCUMENTS = 'GET_ACTIVITY_DOCUMENTS',
    GET_ACTIVITY_DECISIONS = 'GET_ACTIVITY_DECISIONS',
    GET_WF_COMMENTS = 'GET_WF_COMMENTS',
    ADD_WF_COMMENT = 'ADD_WF_COMMENT',
    ADD_DOC_COMMENT = 'ADD_DOC_COMMENT',
    SEARCH_DOCS = 'SEARCH_DOCS',
    GET_DOCUMENTS = 'GET_DOCUMENTS',
    GET_WF_DEFAULT_RECIPIENTS = 'GET_WF_DEFAULT_RECIPIENTS',
    START_WORKFLOW = 'START_WORKFLOW',
    CREATE_WORKFLOW = 'CREATE_WORKFLOW',
    OPEN_FILE = 'OPEN_FILE',
    CHECK_IN_FILE = 'CHECK_IN_FILE',
    CLOSE_ACTIVITY = 'CLOSE_ACTIVITY',
    LOG_PDF_VIEW = 'LOG_PDF_VIEW',
    IMPORT_COMM_FILE = 'IMPORT_COMM_FILE',
    ACK_ACTIVITY = 'ACK_ACTIVITY', 
    CLOSE_ACTIVITY_BL = 'CLOSE_ACTIVITY_BL',
    GET_ACTIVITY_BL = 'GET_ACTIVITY_BL',
    GET_ACT_REC_BL = 'GET_ACT_REC_BL',
  }


